import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { ACCEPTED_IMAGE_TYPES } from '../../../lib/const'
import { ReactComponent as UploadIcon } from '../../../images/icons/upload.svg'

const DropZone = ({ onUpload, onUploadComplete, disabled, uploading, productType }) => {
  const onDrop = useCallback(async (acceptedFiles) => {
    if (disabled) {
      alert('Image upload is disabled until an order is created.');
      return;
    }
    
    // Pass all accepted files directly
    onUpload(acceptedFiles);
  }, [disabled, onUpload, onUploadComplete])

  const { getRootProps, getInputProps, open } = useDropzone({
    accept: ACCEPTED_IMAGE_TYPES,
    onDrop,
    disabled,
  })

  const label = productType === 'albums' ? 'Upload Spreads' : 'Upload Images'

  if (uploading) return null;
  return (
    <div data-ix="fade-up-1" className="accordion js-accordion">
      <div className="accordion__item js-accordion-item">
        <div className="accordion-item-content">
          <div data-ix="hide-on-load" className="accordion-body js-accordion-body">
            <div className="input-container add-notes">
              <div
                className={`upload-div ${disabled ? 'disabled-upload' : ''}`}
                onClick={(e) => {
                  if (disabled) {
                    e.preventDefault();
                    alert('Please create an order before uploading images.');
                  } else {
                    open();
                  }
                }}
                onKeyPress={(e) => {
                  if (!disabled) {
                    open();
                  }
                }}
                role="button"
                tabIndex={0} // For keyboard accessibility
                {...getRootProps()}
              >
                <div className="info-print-order-product-container upload-content">
                  <div className="icon small right-margin w-embed">
                    <UploadIcon />
                  </div>
                  <div>
                    <input {...getInputProps()} disabled={disabled} />
                    <div>{disabled ? 'Create an order to enable upload' : label}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DropZone
